
export default function About() {
  return (
    <section id="about" className="relative py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1">
            <div className="bg-white/5 backdrop-blur-xl rounded-3xl p-8 border border-white/10 shadow-2xl hover:shadow-[#fcd34d]/20 transition-all duration-500 hover:scale-105">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-['Montserrat']">
                About <span className="text-[#fcd34d]">Me</span>
              </h2>
              
              <p className="text-white/80 text-lg mb-6 font-['Roboto'] leading-relaxed">
                Hello! I'm <strong className="text-[#fcd34d]">Syed Abdul Raheem</strong>, a professional graphic designer based in Bangla Gogera, Okara. I specialize in high-end branding, logos, social media designs, posters, and more.
              </p>
              
              <p className="text-white/80 text-lg mb-8 font-['Roboto'] leading-relaxed">
                With attention to detail and creativity, I transform ideas into visually stunning experiences that captivate audiences and elevate brands to new heights.
              </p>

              <div className="space-y-4">
                <div className="flex items-center gap-4 text-white/70 hover:text-[#fcd34d] transition-colors duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#fcd34d]/10 rounded-full">
                    <i className="ri-phone-line text-2xl text-[#fcd34d]"></i>
                  </div>
                  <div>
                    <p className="text-sm text-white/50 font-['Roboto']">Phone</p>
                    <a href="tel:+923440674672" className="text-lg font-semibold font-['Roboto'] cursor-pointer">
                      +92 3440674672
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-4 text-white/70 hover:text-[#fcd34d] transition-colors duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#fcd34d]/10 rounded-full">
                    <i className="ri-mail-line text-2xl text-[#fcd34d]"></i>
                  </div>
                  <div>
                    <p className="text-sm text-white/50 font-['Roboto']">Email</p>
                    <a href="mailto:syedabdulraheem874@gmail.com" className="text-lg font-semibold font-['Roboto'] cursor-pointer break-all">
                      syedabdulraheem874@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-4 text-white/70 hover:text-[#fcd34d] transition-colors duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#fcd34d]/10 rounded-full">
                    <i className="ri-map-pin-line text-2xl text-[#fcd34d]"></i>
                  </div>
                  <div>
                    <p className="text-sm text-white/50 font-['Roboto']">Location</p>
                    <p className="text-lg font-semibold font-['Roboto']">
                      Bangla Gogera, Okara, Pakistan
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="order-1 md:order-2 flex justify-center">
            <div className="relative w-80 h-80">
              <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#fcd34d] to-[#facc15] animate-pulse blur-2xl opacity-40"></div>
              <img
                src="https://i.postimg.cc/LXhMC45P/rahim.jpg"
                alt="Syed Abdul Raheem - Graphic Designer"
                className="relative w-full h-full rounded-full object-cover border-4 border-white/20 shadow-2xl shadow-[#fcd34d]/40"
              />
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[#fcd34d]/30 to-transparent animate-shimmer"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
